import React from "react";
import Grid from "@material-ui/core/Grid";
import Card from "../../../Helper/CardWrapper/cardWrapper";
import ContentGrid from "../../../Helper/gridWrapper/gridWrapper";
import Participants from "./participants";
import HeatMap from "./heatmap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { increaseIndex } from "../../../Actions/heatSpotAction";
import HeatSpotAppView from "./HeatSpotAppView";
import Loader from "../../../Helper/loader/loader";
import { ws } from "../../../App";
import { routeName } from "../../../Service/env";
import Modal from "@material-ui/core/Modal";
import Alert from "../../../Helper/alert/errorAlert";
import CheckoutAlert from "../../../Helper/alert/alert";
import AlertComponent from "../../../Helper/ErrorComponent/errorComponent";
import {
  selectedChat,
  getUnreadCount,
  increaseMessageIndex,
  clearData,
  setInitial,
  unreadCountToZero,
  removeEmptyDialog,
  emptyBackupChat,
  unselectChat,
  emptyLiveChat,
} from "../../../Actions/messagesAction";
import "./heatSpot.css";
import WebView from "../Messages/WebView";
import { userCheckOut } from "../../../Actions/index";
import store from "../../../store";
import liveChatReducer from "../../../Reducers/liveChatReducer";
import {audioFunc} from "../../../Service/helper";

class HeatSpot extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      connected: false,
      showAlert: false,
      showCheckoutAlert: false,
      alertMessage: "",
      googleMapURL: "",
      userMessagesModalIsOpen: false,
      userMessages: {},
      showGif: false,
      dataToDelete: {},
      userId: Number(this.props.userDetails.AppUser.UserId),
      showInfo: false,
    };
  }

  connection = () => {

    if (!this.state.connected && this.props.isOpen) {
      // if (
      //   !this.props.liveChatData.liveChat &&
      //   this.props.userDetails.BusinessUser.PlaceID
      // ) {
        ws.json({
          index: 0,
          count: 20,
          user_id: this.props.userDetails.AppUser.UserId,
          type: "businessrecentchat",
          chat_type: "Business",
          deleteCount: "0",
          googlePlacedId: this.props.userDetails.BusinessUser.PlaceID,
        });
        this.props.increaseIndex();
        this.setState({
          connected: true,
        });
      // }
    }
  };

  temp = () => {
    this.props.history.push(`/${routeName}/Dashboard/Deal`);
  };

  onCLoseImage = () => {
    document.getElementById("myModal").style.display = "none";
  };

  toggleAlert = (msg) => {
    this.setState({
      showAlert: !this.state.showAlert,
      alertMessage: msg,
    });
  };

  showUserMessagesModal = (userMessages) => {
    this.setState({
      userMessagesModalIsOpen: true,
      userMessages,
    });
  };

  showCheckout = (checkedInUserData) => {
    this.setState({
      showCheckoutAlert: true,
      checkedInUserData: checkedInUserData,
    });
  };

  hideCheckout = () => {
    this.setState({
      showCheckoutAlert: false,
      checkedInUserData: "",
    });
  };

  checkoutUser = () => {
    if (this.state.showCheckoutAlert) {
      const placeId =
        store.getState().loginResponse.results.BusinessUser.PlaceID;
      let data = {
        GooglePlaceId: placeId,
        UserId: this.state.checkedInUserData.UserId,
      };
      // console.log(data);

      userCheckOut(data);

      this.hideCheckout();
    }
  };

  closeUserMessagesModal = (data) => {
    const { messageData } = this.props;
    if (Object.keys(messageData.selectedChat.last_message_json).length == 0) {
      this.props.removeEmptyDialog(data);
    }
    localStorage.removeItem("curbsideCommunicationUserId");
    localStorage.removeItem("curbsideCommunicationUserName");
    localStorage.removeItem("curbsideCommunicationFullName");
    localStorage.removeItem("curbsideCommunicationProfileImage");
    this.setState({
      userMessagesModalIsOpen: false,
      userMessages: {},
    });
  };

  componentWillUnmount() {
    this.props.emptyBackupChat();
    this.props.emptyLiveChat();
  }

  updateState = (state, value) => {
    this.setState({
      [state]: value,
    });
  };

  userMessagesModalStyles = () => {
    return {
      position: "fixed",
      top: window.screen.Height < 1100 ? "10%" : "5%",
      width:
        window.screen.width < 1100
          ? window.screen.width < 850
            ? "84%"
            : "55%"
          : "",
      left:
        window.screen.width < 1100
          ? window.screen.width < 850
            ? "8%"
            : "22%"
          : "30%",
      right:
        window.screen.width < 1100
          ? window.screen.width < 850
            ? "8%"
            : "22%"
          : "30%",
      borderRadius: "8px",
      backgroundColor: "white",
    };
  };

  imageClicked = (e, data) => {
    let { audioURL } = this.state;
    if (JSON.parse(data.message_json).text === "[Sticker message]") {
      if (Number(JSON.parse(data.message_json).stickerId.split(".")[0]) <= 30) {
        audioURL = require(`../../../Sounds/${
          JSON.parse(data.message_json).stickerId.split(".")[0]
        }.wav`);
        audioFunc(false, false, audioURL)
      } else {
        audioURL = `https://d2gnb7jphto2jj.cloudfront.net/ChatImages/Sticker/Sounds/${
          JSON.parse(data.message_json).stickerId.split(".")[0]
        }.wav`;
        audioFunc(false, false, audioURL)
      }
    } else if (
      JSON.parse(data.message_json).text === "[GIF message]" ||
      JSON.parse(data.message_json).text === "[Picture message]"
    ) {
      let modal = document.getElementById("myModal");
      let targetDestination = document.getElementById("zoomImage");
      modal.style.display = "block";
      targetDestination.src = e.target.src;
    }
    this.setState({ audioURL });
  };

  updateWebViewState = (state, value) => {
    this.setState({
      [state]: value,
    });
  };

  MouseDown = (e) => {
    this.setState({
      pressStart: e.timeStamp,
    });
  };

  MouseUp = (e, data) => {
    if (this.state.pressStart + 1000 < e.timeStamp) {
      if (
        Number(data.from_user_id) === this.props.userId ||
        data.GooglePlaceId ||
        data.GooglePlacedId
      ) {
        if (data.RowNumber !== "1") {
          this.setState({
            dataToDelete: {
              data: data,
            },
            showDelete: true,
          });
        }
      }
    } else {
      if (!data.GooglePlaceId && !data.GooglePlacedId) {
        this.imageClicked(e, data);
      }
    }
  };

  onGifClick = () => {
    this.setState({
      showGif: !this.state.showGif,
    });
  };

  userMessagesModal = (data) => {
    const { messageData } = this.props;
    const { userMessagesModalIsOpen, userId } = this.state;
    let selectedChatIndex = -1;
    if (userMessagesModalIsOpen) {
      messageData.recentChat.forEach((message, index) => {
        if (data.UserId + "" === message.userid) {
          selectedChatIndex = index;
        }
      });
    }
    let showInfo = false;
    return (
      <Modal
        open={userMessagesModalIsOpen}
        onClose={() => this.closeUserMessagesModal(data)}
      >
        <Card
          CardContentProps={{
            style: this.userMessagesModalStyles(),
          }}
          content={
            <WebView
              userId={userId}
              updateState={this.updateState}
              toggleAlert={this.toggleAlert}
              showInfo={showInfo}
              curbsideCommunication={true}
              curbsideCommunicationUserData={{
                FullName: data.FirstName,
                ProfileImage: data.ProfileImage,
                UserName: data.UserName,
                UserId: data.UserId,
              }}
              curbsideCommunicationSelectedChatIndex={selectedChatIndex}
            />
          }
        />
      </Modal>
    );
  };

  render() {
    const { error } = this.props;
    const { showAlert, alertMessage, showCheckoutAlert } = this.state;
    !this.state.connected && this.connection();
    return (
      <React.Fragment>
        {showAlert && (
          <AlertComponent msg={alertMessage} clickMethod={this.toggleAlert} />
        )}
        {error && <Alert />}
        {showCheckoutAlert && (
          <CheckoutAlert
            warning="true"
            showCancel="true"
            confirmText="Yes"
            confirmStyle="danger"
            cancelStyle="default"
            title={<span>"Are you sure you want to check out this user?"</span>}
            Confirm={this.checkoutUser}
            Cancel={this.hideCheckout}
          />
        )}
        <div className="container-div">
          {this.userMessagesModal(this.state.userMessages)}
          {this.props.userDetails.BusinessUser.BusinessName ? (
            <ContentGrid
              content={
                <Grid
                  container
                  spacing={24}
                  xs={24}
                  sm={24}
                  md={24}
                  className="location-heat-spot"
                >
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    className="custom-grid-width"
                  >
                    <section>
                      <Card
                        content={<HeatMap />}
                        CardContentProps={{
                          style: { height: "calc(100vh - 400px)" },
                        }}
                        actions={<span />}
                      />
                    </section>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    className="custom-grid-width"
                  >
                    <Participants
                      showUserMessagesModal={this.showUserMessagesModal}
                      userMessagesModalIsOpen={
                        this.state.userMessagesModalIsOpen
                      }
                      toShow={false}
                      showCheckout={this.showCheckout}
                    />
                  </Grid>
                </Grid>
              }
              appView={
                <Card
                  content={
                    <HeatSpotAppView
                      userDetails={this.props.userDetails}
                      liveChatData={this.props.liveChatData}
                      toggleAlert={this.toggleAlert}
                    />
                  }
                  CardContentProps={{
                    style: {
                      paddingLeft: "0px",
                      paddingRight: "0px",
                      paddingBottom: "0px",
                    },
                  }}
                />
              }
            />
          ) : (
            <Loader />
          )}
          <div id="myModal" className="modal">
            <span className="close custom-close" onClick={this.onCLoseImage}>
              &times;
            </span>
            <img className="modal-content" id="zoomImage" alt="img" />
          </div>
        </div>
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    user: state.loginResponse,
    isOpen: state.messageReducer.connection,
    userDetails: state.loginResponse.results,
    liveChatData: state.liveChatReducer,
    liveChatIndex: state.liveChatReducer.liveChatIndex,
    error: state.messageReducer.error,
    messageData: state.messageReducer,
    messageIndex: state.messageReducer.messageIndex,
  };
};

const matchDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      increaseIndex,
      selectedChat,
      getUnreadCount,
      setInitial,
      increaseMessageIndex,
      clearData,
      unreadCountToZero,
      removeEmptyDialog,
      emptyBackupChat,
      emptyLiveChat,
      unselectChat,
    },
    dispatch
  );
};

export default connect(mapStateToProps, matchDispatchToProps)(HeatSpot);
